import moment from "moment";
import React from "react";
import { humanizeNumbers } from "../../../../utils/format";

const BOOKING_STATUS_COLOR: Record<string, string> = {
  pending: "bg-yellow-200",
  confirmed: "bg-green-200",
  cancelled: "bg-gray-300",
  noshow: "bg-red-200",
  checked_in: "bg-blue-200",
  checked_out: "bg-blue-200",
};

interface UserBookingCardProps {
  bookingData: any;
  onPress: any;
}

const BookingCard: React.FC<UserBookingCardProps> = ({
  bookingData,
  onPress,
}) => {
  const statusColor = BOOKING_STATUS_COLOR[bookingData.status] || "bg-gray-200";
  const formattedCheckin = moment(bookingData.checkin).format("D MMM' YY");
  const formattedCheckout = moment(bookingData.checkout).format("D MMM' YY");

  return (
    <div
      className="bg-white border border-accent shadow-sm rounded-lg flex flex-col md:flex-row items-stretch cursor-pointer hover:shadow-lg transition-all ease-in-out duration-150"
      onClick={() => onPress(bookingData)}
    >
      <img
        className="object-cover w-full h-32 md:w-48 md:h-full flex-shrink-0 rounded-t-lg md:rounded-t-none md:rounded-l-lg"
        src={bookingData.operator.cover_image || ""}
        alt={`${bookingData.operator.name} Cover`}
      />

      <div className="flex flex-col flex-1 p-4">
        <div
          className={`flex self-start items-center justify-between px-2 py-1 rounded-full ${statusColor}`}
        >
          <p className="text-xxs font-medium uppercase tracking-wide text-gray-900">
            {bookingData.status}
          </p>
        </div>
        <p className="text-lg font-medium text-gray-900 mt-1">
          {bookingData.operator.name}
        </p>

        <div className="flex justify-between mt-2 items-end">
          <div className="flex items-center gap-x-4">
            <div className="flex flex-col">
              <span className="text-xs font-medium tracking-wide text-gray-600 uppercase">
                Check in
              </span>
              <span className="text-sm font-medium text-text">
                {formattedCheckin}
              </span>
            </div>

            <i className="uil uil-arrow-right text-2xl" />

            <div className="flex flex-col">
              <span className="text-xs font-medium tracking-wide text-gray-600 uppercase">
                Check out
              </span>
              <span className="text-sm font-medium text-text">
                {formattedCheckout}
              </span>
            </div>
          </div>

          <p className="font-medium text-gray-900 shrink-0">
            ₹{humanizeNumbers(bookingData.total_amount)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingCard;
